import { Toaster } from "react-hot-toast";
import Layout from "./shared/Layout";
import { useEffect, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { API_URL, baseurl } from "../_config";

const Enquiry = () => {
    const navigate = useNavigate();
    const [error, setError] = useState();
    const [enquiries, setEnquiries] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);

    const fetchEnquiries = async () => {
        try {
            const response = await axios.get(`${baseurl}${API_URL.getEnquiries}`);
            if (response?.data?.isSuccess === true) {
                setEnquiries(response?.data?.data)
            }
        } catch (error) {
            return null;
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchEnquiries();
    }, []);

    useEffect(() => {
        if (searchTerm) {
            const filtered = enquiries?.filter(item =>
                (item.name && item.name.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.email && item.email.toString().includes(searchTerm.toString())) ||
                 (item.phoneNumber && item.phoneNumber.toString().includes(searchTerm.toString()))
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(enquiries);
        }
    }, [searchTerm, enquiries]);

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '80px',
        },
        {
            name: 'Name',
            selector: row => (
                <div>{row.name}</div>
            ),
            sortable: true,
            minWidth: '150px'
        },
        {
            name: 'Email Id',
            selector: row => (
                <div className="" >
                    <h6>{row.email}</h6>
                    <span>{row?.phoneNumber}</span>
                </div>
            ),
            sortable: true,
            minWidth: '250px'
        },
        {
            name: 'Query Type',
            selector: row => row.queryType,
            sortable: false,
            minWidth: '150px'
        },
        {
            name: 'Message',
            selector: row => row.message,
            sortable: false,
            minWidth: '200px'

        },
    ];

    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="right-content-section">
                <div className="admin-page mt-3 d-flex justify-content-between align-items-center">
                    <div className="admin-heading">
                        <h4 className="mb-0">Enquiry</h4>
                    </div>
                    <div className="d-md-flex align-items-center justify-content-end">
                        <div className="search-container ">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>
                {error ? (
                    <p>Data not avaiable</p>
                ) : (
                    <div className="datatable mt-4">
                        <DataTable
                            columns={columns}
                            data={filteredData || []}
                            progressPending={loading}
                            progressComponent={<p>Loading...</p>}
                            pagination
                            highlightOnHover
                        />
                    </div>
                )}
            </div>
        </Layout>
    )
}

export default Enquiry;